let _ = t => t,
  _t;
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import Bounds from 'automation-ui-directed-graph/Bounds';
import CurvePoints from 'automation-ui-directed-graph/CurvePoints';
import { rounded } from 'automation-ui-directed-graph/utils/svg';
export default class GoToPath extends createImmutableObjectClass({
  isHover: false,
  isGoToEditNode: false,
  pathId: '',
  shouldShowEndMarker: true,
  points: new CurvePoints(),
  lineStrokeWidth: 0,
  markerWidth: 0,
  markerHeight: 0
}, {
  fromJSON: json => {
    const {
      points: {
        p0x,
        p0y,
        p1x,
        p1y,
        p2x,
        p2y,
        p3x,
        p3y
      },
      shouldShowEndMarker,
      lineStrokeWidth = 0,
      markerWidth = 0,
      markerHeight = 0
    } = json;
    const paddingX = Math.ceil((lineStrokeWidth + (shouldShowEndMarker ? markerWidth : 0)) / 2);
    const paddingY = Math.ceil((lineStrokeWidth + (shouldShowEndMarker ? markerHeight : 0)) / 2);
    return Object.assign({}, json, {
      points: new CurvePoints({
        p0x,
        p0y,
        p1x,
        p1y,
        p2x,
        p2y,
        p3x,
        p3y
      }),
      bounds: new Bounds({
        minX: Math.round(Math.min(p0x, p1x, p2x, p3x)) - paddingX,
        minY: Math.round(Math.min(p0y, p1y, p2y, p3y)) - paddingY,
        maxX: Math.round(Math.max(p0x, p1x, p2x, p3x)) + paddingX,
        maxY: Math.round(Math.max(p0y, p1y, p2y, p3y)) + paddingY
      }),
      path: rounded(_t || (_t = _`M ${0} ${0} C ${0} ${0} ${0} ${0} ${0} ${0}`), p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y)
    });
  },
  toJSON: record => record
}) {
  split(numberOfSegments) {
    if (numberOfSegments === 1) {
      return [this];
    }
    const {
      pathId,
      shouldShowEndMarker
    } = this;
    const lastSegmentIndex = numberOfSegments - 1;
    return this.points.split(numberOfSegments).map((points, index) => new GoToPath(Object.assign({}, this.toJSON(), {
      points,
      pathId: `${pathId}-${index}`,
      shouldShowEndMarker: shouldShowEndMarker && index === lastSegmentIndex
    })));
  }
}